import { render, staticRenderFns } from "./ComparisonChartTable.vue?vue&type=template&id=1dc7f3c2&"
import script from "./ComparisonChartTable.vue?vue&type=script&lang=js&"
export * from "./ComparisonChartTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports